import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router';
import './i18n';
import { QueryClient, QueryClientProvider } from 'react-query';
import { MsalProvider } from '@azure/msal-react';
import { App as AntdApp } from 'antd';
import { msalInstance } from 'services/msal';
import ScrollToTop from 'components/ui/scroll-to-top';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

const queryClient = new QueryClient();

// Initialize MSAL
msalInstance
  .initialize()
  .then(() => {
    msalInstance.handleRedirectPromise();

    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );

    root.render(
      <React.StrictMode>
        <AntdApp>
          <MsalProvider instance={msalInstance}>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <ScrollToTop />
                <App />
              </BrowserRouter>
            </QueryClientProvider>
          </MsalProvider>
        </AntdApp>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('Failed to initialize MSAL:', error);
  });
